import { getT } from "@/utils/intlUtils";

// 调拨类型
export enum TransferTypeEnum {
  Standard = 1, //标准
  Regional = 2, //区域
  SP = 4, //服务商
}

export const getTypeMaps = () => {
  const t = getT("transfer");
  return {
    [TransferTypeEnum.Standard]: {
      color: "#45629D",
      label: t("标准"),
    },
    [TransferTypeEnum.Regional]: {
      color: "#56C1D7",
      label: t("区域"),
    },
    [TransferTypeEnum.SP]: {
      color: "#FDB358",
      label: t("服务商"),
    },
  };
};

export function getTitleMap(): Record<string, string> {
  const t = getT("transfer");
  return {
    goodPosition: t("新件申请"),
    oldPosition: t("旧件申请"),
    badPosition: t("坏件申请"),
  };
}
